<div class="container">
    <div class="alert alert-success" role="alert">
        <p>Estimado Postulante:</p>
        <!--<p>Bienvenido a la plataforma de Universidad Santo Tom&aacute;s, realiza tu matr&iacute;cula online en la carrera seleccionada de manera aut&oacute;noma y segura. En el men&uacute; lateral encontrar&aacute;s la secci&oacute;n &ldquo;nuevo proceso&rdquo;
            donde deber&aacute;s completar los datos faltantes y realizar tu matr&iacute;cula.&nbsp;
        </p>-->
        <p>
            Bienvenido a la plataforma de Matr&iacute;cula Online de la Universidad Santo Tom&aacute;s. Aqu&iacute; podr&aacute; 
            realizar de manera aut&oacute;noma y a distancia el proceso de matr&iacute;cula en la carrera de su inter&eacute;s. 
            Para iniciar, deber&aacute; seleccionar en el men&uacute; lateral la secci&oacute;n “nuevo proceso”, 
            donde podr&aacute; completar los datos requeridos para la matr&iacute;cula.
        </p>
    </div>
    <div class="border border-success rounded">

        <div class="hidden-md-down">
            <hr>
        </div>

        <div *ngIf="!lista" class="ml-2 mr-2">
            <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">Buscando</h4>

                <hr>
                <app-progress></app-progress>
                <p class="mb-0">Cargando registros...</p>
            </div>
        </div>
        <div class="ml-2 mr-2">
            <app-admision [proceso]='item' *ngFor="let item of lista" (onCancelProceso)="onCancelProceso($event)">
            </app-admision>

        </div>

    </div>
</div>

<app-modal-messages></app-modal-messages>